module.exports = __webpack_public_path__ + "static/hatton-logo-54c58e14797fe5dd1bd61e52ce7d671e.svg";